import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import TitleComponent from "../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';

const InterviewProcess = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box 
                className="sectionSpacing"
                px='5%'
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <TitleComponent 
                    title={t('careers.interview.title')}
                    description={t('careers.interview.description')}
                    centerMode
                />

                <Grid
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    container
                    spacing={{xs: 3, md: 10}}
                >
                    <Grid size={{xs: 12, md: 6}}>
                        <InterviewDetails 
                            step={1}
                            title={t('careers.interview.step1.title')}
                            description={t('careers.interview.step1.description')}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <InterviewDetails 
                            step={2}
                            title={t('careers.interview.step2.title')}
                            description={t('careers.interview.step2.description')}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <InterviewDetails 
                            step={3}
                            title={t('careers.interview.step3.title')}
                            description={t('careers.interview.step3.description')}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <InterviewDetails 
                            step={4}
                            title={t('careers.interview.step4.title')}
                            description={t('careers.interview.step4.description')}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default InterviewProcess;

const InterviewDetails = ({
    step,
    title,
    description
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='center'
                position='relative'
            >
                <Gauge
                    width={150}
                    height={150}
                    value={step * 25}
                    cornerRadius="50%"
                    sx={(theme) => ({
                        [`& .${gaugeClasses.valueText}`]: {
                            fontSize: 40,
                            fontFamily: theme.typography.fontFamily,
                            display: 'none'
                        },
                        [`& .${gaugeClasses.valueArc}`]: {
                            fill: theme.palette.primary.main,
                        },
                        [`& .${gaugeClasses.referenceArc}`]: {
                            fill: theme.palette.background.paper,
                        },
                    })}
                />

                <Typography
                    fontWeight={600}
                    fontSize={40}
                    textAlign='left'
                    color={theme.palette.text.primary}
                    lineHeight={1.5}
                    position='absolute'
                    top={45}
                >
                    {`0${step}`}
                </Typography>

                <Typography
                    fontWeight={600}
                    fontSize={{xs: 16, md: 24}}
                    textAlign='left'
                    color={theme.palette.text.primary}
                    lineHeight={1.5}
                    pt={{xs: 3, md: 5}}
                    pb={{xs: 1, md: 2}}
                >
                    {title}
                </Typography>
                    
                <Typography
                    fontWeight={500}
                    fontSize={{xs: 12, md: 12, lg: 14}}
                    textAlign="center"
                    lineHeight={1.5}
                    color={theme.palette.text.secondary}
                >
                    {description}
                </Typography>
            </Stack>
        </>
    );
}